import { render, staticRenderFns } from "./ServiceNotes.vue?vue&type=template&id=7f988fec&scoped=true"
import script from "./ServiceNotes.vue?vue&type=script&lang=js"
export * from "./ServiceNotes.vue?vue&type=script&lang=js"
import style0 from "./ServiceNotes.vue?vue&type=style&index=0&id=7f988fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f988fec",
  null
  
)

export default component.exports